import {
    CircularProgress,
    Grid,ToggleButton,
    InputAdornment,
    TextField, Button,Box
  } from "@mui/material";
  import { DragHandleRounded, Search, SentimentDissatisfied } from "@mui/icons-material";
  import React, { useEffect, useState } from "react";
  import { useSnackbar } from "notistack";
  import axios from "axios";
  import { styled } from "@mui/material/styles";

  const Age = ({contentRating, setCR})=>{
    
    const [ageGroup, setAgeGroup]=useState(
        [
            { name: "Any age group", isActive: true , value:"Anyone"},
            { name: "7+", isActive: false , value: "7%2B" },
            { name: "12+", isActive: false, value: "12%2B" },
            { name: "16+", isActive: false , value: "16%2B"},
            {name: "18+", isActive: false, value: "18%2B"}
        ]
      );

      const ColorButton = styled(ToggleButton)({
        textTransform: "capitalize",
        color: "#ffffff",
        fontsize: "1.5rem",
        background: "none",
        border: "none",
        height: "2rem",
        borderRadius: "16px",
        boxShadow: "none",
        fontWeight: "400",
        "&.Mui-selected:hover": {
          backgroundColor: "#ededed",
          color: "#000000",
          borderRadius: "16px",
        },
        "&.Mui-selected": {
          backgroundColor: "#ffffff",
          color: "#000000",
          borderRadius: "16px",
        },
        "&:focus": {
          backgroundColor: "#ffffff",
          color: "#000000",
          borderRadius: "16px",
        },
      });
    
      const handler = async (e, index)=>{
        console.log("event", e.target.value);
        let selectedAge = e.target.value;
        setCR(selectedAge);
        if (contentRating === selectedAge) {
          setCR("Anyone");
        }
      }

      return(
        <Grid container
        direction="row"
        justifyContent={{xs:"space-evenly",md:"center"}}
        alignItems="center"
        spacing={{xs:0,md:5}}marginLeft="1rem">
            {
                ageGroup.map((el, index) =>{
  
                  return (
                    <Grid item mt={1} key ={index}>
                    <ColorButton key={index}  variant="contained" selected={contentRating === el.value ? true : false} value={el.value}onClick={async (e)=>{ await handler(e,index)}}>
                      {el.name}
                  </ColorButton>
                  </Grid>
                  );
                })}
  
            </Grid>
      )
  }

  export default Age;